(function () {
    'use strict';

    angular.module('swif.ui')
    .controller('PrintModalController', PrintController);

    function PrintController ($scope, gettextCatalog){
        'ngInject';
        console.log('init PrintController');
        var report = $scope.action.reports[0];
        $scope.model._report = [report.id, report.name];
        // -- specifique controls for 'patrimoine_equipment' items to print (see print.html)

        var printQuantityOptions = [
            {id: 'matchingStock', name: gettextCatalog.getString('Correspondant à la quantité en stock')},
            {id: 'manual', name: gettextCatalog.getString('Défini manuellement ')}
        ];
        $scope.model.options = {
            available: printQuantityOptions,
            selected: printQuantityOptions[0]
        };
        $scope.model.fixedNumberToPrint=1;
        $scope.model.context = {
            report_ctx: {
                "copies_nb": 1,
                "display_name": true,
                'barcodes_per_line':3
            },
            "items_params": {}
        };
        // TODO :factoriser dans barcode.js ?
        if ($scope.action.id === 'print') {
            $scope.model.context.items_params[$scope.model.id]={
                'copies_nb': Math.max($scope.model.qty_available, 0)
            };
        }
        if ($scope.action.id === 'print_collection') {
            for (var item of $scope.model.items) {
                $scope.model.context.items_params[item.id]={
                    'copies_nb': Math.max(item.qty_available, 0)
                };
            }
            var barcode_reports = $scope.action.barcode_reports;
            if (barcode_reports) {
                $scope.model._reportEAN13 = [barcode_reports[0].id, barcode_reports[0].name];
                $scope.model._reportCode128 = [barcode_reports[1].id, barcode_reports[1].name];

                var listEAN13 = [];
                var listCode128 = [];
                $scope.model.items.forEach(function (consumable){
                    var code = consumable.default_code;
                    if (code.length === 13 && Number(code) === parseInt(code)) {
                        listEAN13.push(consumable);
                    } else {
                        listCode128.push(consumable);
                    }
                });
                if (listEAN13.length && listCode128.length) {
                    $scope.multiple_pdf = gettextCatalog.getString("Warning : this will print one pdf for each type of barcode");
                }
                $scope.model.listCode128 = listCode128;
                $scope.model.listEAN13 = listEAN13;
            }
        }
        $scope.changeOption = function() {
            if ($scope.model.options.selected.id==='manual'){
                $scope.model.displayFixedNumberToPrint=true;
                $scope.model.context.items_params = {};
                $scope.model.context.report_ctx.copies_nb = $scope.model.fixedNumberToPrint;
            }
            if ($scope.model.options.selected.id==='matchingStock'){
                // we contruct items_params
                $scope.model.displayFixedNumberToPrint=false;
                $scope.model.context.items_params = {};
                if ($scope.action.id === 'print_collection') {
                    for (var item of $scope.model.items) {
                        $scope.model.context.items_params[item.id]={'copies_nb': item.qty_available};
                    }
                }
                if ($scope.action.id === 'print') {
                    $scope.model.context.items_params[$scope.model.id]={'copies_nb': $scope.model.qty_available};
                }
            }
        };
    }

})();
